var React = require('react');

function RightArrowAlt (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.248 11L0.448049 0.607696L0.448048 21.3923L11.248 11Z","fill":"#676A72"}));
}

RightArrowAlt.defaultProps = {"width":"12","height":"22","viewBox":"0 0 12 22","fill":"none"};

module.exports = RightArrowAlt;

RightArrowAlt.default = RightArrowAlt;
